module.exports = __webpack_public_path__ + "static/media/datasheet_musicData_row0_startplaying.8fadac09.png";